import { DefaultCell } from "../../../../Component/Common/Components/DataTable/DefaultCell";
import { TableColumn } from "../../../../Component/Model/Table/Table";
import { StringDateTimeHelper } from "../../../../Component/Model/helpers";
import { UserActivityDto } from "../../../../Component/Model/Dto/UserActivity";

interface UserActivityRows {
    ID: number;
    Username: string;
    UserType: string;
    ActionDateTime: string;
    ScorecardName: string;
    Section: string;
    ActivityDescription: string;
}

interface UserActivityTable {
    columns: Array<TableColumn>;
    rows: Array<UserActivityRows>;
}

export function UserActivityTrackingTableMapper(dataObject: UserActivityDto[]): UserActivityTable {
    const columns = [
        { Header: 'Username', accessor: 'Username', Cell: ({ value }: any) => <DefaultCell value={value} tooltip={true} /> },
        { Header: 'User Type', accessor: 'UserType', Cell: ({ value }: any) => <DefaultCell value={value} tooltip={true} /> },
        { Header: 'Action Date/Time', accessor: 'ActionDateTime', Cell: ({ value }: any) => <DefaultCell value={value} tooltip={true} /> },
        { Header: 'Scorecard Name', accessor: 'ScorecardName', Cell: ({ value }: any) => <DefaultCell value={value} tooltip={true} /> },
        { Header: 'Section', accessor: 'Section', Cell: ({ value }: any) => <DefaultCell value={value} tooltip={true} /> },
        { Header: 'Activity Description', accessor: 'ActivityDescription', Cell: ({ value }: any) => <DefaultCell value={value} tooltip={true} /> }
    ];

    if (dataObject.length > 0) {
        const rows = dataObject.map((item: UserActivityDto) => ({
            ID: item.id,
            Username: item.userName || 'N/A',
            UserType: item.userType || 'N/A',
            ActionDateTime: StringDateTimeHelper(item.actionDateTime, true) || 'N/A',
            ScorecardName: item.scorecardName || 'N/A',
            Section: item.section || 'N/A',
            ActivityDescription: item.actionDescription || 'N/A'
        }));
        return { columns: columns, rows: rows };
    } else {
        return { columns: columns, rows: [] };
    }
}
